<template>
  <div class="main user-layout-register">
    <div
      class="kong"
      v-if="list.length == 0"
    >
      暂无数据
    </div>
    <div v-else>
      <div class="camers">
        <div
          class="video_s"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="video_t">
            <div
              class="video_t_l"
              @click="handleQie(item, index)"
            >切换</div>
            <div>{{ item.name }}</div>
            <div class="video_t_r"></div>
          </div>
          <div
            :id="'playWind' + index"
            class="video_k"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDev, cameraPage } from '@/api/device'
import ezuikit from '@/utils/ezuikit.js'
export default {
  name: 'Register',
  // components: { videoPlayer },
  data () {
    return {
      siteId: '',
      list: []
    }
  },
  computed: {},
  created () {
    let index = window.location.href.indexOf('id=')
    this.siteId = window.location.href.substring(index + 3)
    console.log(this.siteId, '大大大大大');
    this.getDetail()
  },
  beforeDestroy () {
    this.getClose()
    if (this.list.length) {
      this.list.forEach((v, index) => {
        v.stopPromise = v.EZOPENDemo.stop()
        v.stopPromise.then((data) => {
          console.log('promise 获取 数据', data)
        })
        v.EZOPENDemo.stop()
        v.destroyPromise = v.EZOPENDemo.destroy();
        v.destroyPromise.then((data) => {
          console.log("promise 获取 数据", data)
          document.getElementById('playWind' + index).innerHTML = ''
        })
      })
    }
  },
  methods: {
    handleQie (item, index) {
      item.stopPromise = item.EZOPENDemo.stop()
      item.stopPromise.then((data) => {
        console.log('promise 获取 数据', data)
      })
      item.EZOPENDemo.stop()
      document.getElementById('playWind' + index).innerHTML = ''
      if (item.isShow == 1) {
        item.isShow = 2
      } else {
        item.isShow = 1
      }
      item.ezopenInit()
    },
    getDetail () {
      cameraPage({ siteId: this.siteId }).then(res => {
        res = res.data.records
        if (res.length) {
          res.forEach((v, index) => {
            v.EZOPENDemo = null
            v.isShow = 1
            v.ezopenInit = () => {
              v.EZOPENDemo = new EZUIKit.EZUIKitPlayer({
                id: 'playWind' + index,
                width: '550',
                height: '350',
                template: 'pcLive',
                url: 'ezopen://open.ys7.com/' + v.code + '/' + v.isShow + '.live',
                accessToken: v.accessToken
              })
            }
            v.ezopenInit()
          });
        }
        this.list = res
        console.log(res, 'resresres');
      })
    },
  }
}
</script>

<style lang="less" scoped>
.kong {
  font-size: 20px;
  text-align: center;
  margin-top: 30px;
}

.video_s {
  width: 550px;
  height: 450px;
  position: relative;
  margin-right: 50px;

  .video_t {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .video_t_l {
      width: 80px;
      height: 30px;
      display: flex;
      align-items: center;
      border-radius: 3px;
      cursor: pointer;
      color: #ffffff;
      justify-content: center;
      background: #2878ff;
      z-index: 666;
    }

    .video_t_r {
      width: 80px;
      height: 30px;
    }
  }

  .video_k {
    width: 450px;
    height: 350px;
  }
}

.camers {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
</style>
